// src/api/modules/OrderGeneralApi.js
import Methods from "../methods";

const saveOrderGeneral = (context, payload) => {
  const { file, data } = payload;

  const formData = new FormData();
  formData.append("file", file);
  formData.append("data", new Blob([JSON.stringify(data)], { type: "application/json" }));

  const url = `/orderGeneral/save`;
  return Methods.doPostMultipart(context, url, formData);
};

export default {
  saveOrderGeneral,
};



// WEBPACK FOOTER //
// ./src/api/modules/OrderGeneralApi.js